export default __webpack_public_path__ + "static/media/join.6230e23b.png";